
import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import { ApplicationFormData, jobPositions, experienceLevels } from './ApplicationFormSchema';

interface JobInfoFieldsProps {
  form: UseFormReturn<ApplicationFormData>;
}

const JobInfoFields = ({ form }: JobInfoFieldsProps) => {
  return (
    <div className="grid md:grid-cols-2 gap-4">
      <FormField
        control={form.control}
        name="jobPosition"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Poste souhaité *</FormLabel>
            <Select onValueChange={field.onChange} defaultValue={field.value}>
              <FormControl>
                <SelectTrigger id="job-position">
                  <SelectValue placeholder="Sélectionnez un poste" />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                {jobPositions.map((position) => (
                  <SelectItem key={position} value={position}>
                    {position}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="experience"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Niveau d'expérience *</FormLabel>
            <Select onValueChange={field.onChange} defaultValue={field.value}>
              <FormControl>
                <SelectTrigger>
                  <SelectValue placeholder="Votre expérience" />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                {experienceLevels.map((level) => (
                  <SelectItem key={level} value={level}>
                    {level}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};

export default JobInfoFields;
